const routes = [
  {
    path: "/manutencao-complemento-ensino",
    name: "manutencao-complemento-ensino",
    meta: {
      allowedPermissions: ["complemento_ensino_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoComplementoEnsino/ManutencaoComplementoEnsinoHome.vue"
      ),
  },
  {
    path: "/manutencao-complemento-ensino/novo",
    name: "manutencao-complemento-ensino-novo",
    meta: {
      allowedPermissions: ["complemento_ensino_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoComplementoEnsino/ManutencaoComplementoEnsinoCad.vue"
      ),
  },
  {
    path: "/manutencao-complemento-ensino/editar/:id",
    name: "manutencao-complemento-ensino-editar",
    meta: {
      allowedPermissions: ["complemento_ensino_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoComplementoEnsino/ManutencaoComplementoEnsinoEdit.vue"
      ),
  },
];

export default routes;
